/// <reference path="../app.ts" />
namespace Cfnc {
    export interface ICommunityCollege {
        name: string;
        applicationDefinitionId: string;
    }

    export interface ICommunityCollegeService {
        getCommunityColleges: () => ICommunityCollege[];
    }

    export class CommunityCollegeService implements ICommunityCollegeService {
        static serviceId: string = "communityCollegeService";

        constructor() { }

        getCommunityColleges() {
            return [
                {
                    name: "Alamance Community College",
                    applicationDefinitionId: "organizations/1/programs/1/applications/1"
                },
                {
                    name: "Asheville-Buncombe Technical Community College",
                    applicationDefinitionId: "organizations/289/programs/148/applications/163"
                },
                {
                    name: "Beaufort County Community College",
                    applicationDefinitionId: "organizations/291/programs/214/applications/229"
                },
                {
                    name: "Bladen Community College",
                    applicationDefinitionId: "organizations/294/programs/223/applications/238"
                },
                {
                    name: "Blue Ridge Community College",
                    applicationDefinitionId: "organizations/295/programs/226/applications/241"
                },
                {
                    name: "Brunswick Community College",
                    applicationDefinitionId: "organizations/297/programs/232/applications/247"
                },
                {
                    name: "Caldwell Community College and Technical Institute",
                    applicationDefinitionId: "organizations/299/programs/238/applications/253"
                },
                {
                    name: "Cape Fear Community College",
                    applicationDefinitionId: "organizations/301/programs/244/applications/259"
                },
                {
                    name: "Carolinas College of Health Sciences",
                    applicationDefinitionId: "organizations/999/programs/999/applications/999"
                },
                {
                    name: "Carteret Community College",
                    applicationDefinitionId: "organizations/302/programs/247/applications/262"
                },
                {
                    name: "Catawba Valley Community College",
                    applicationDefinitionId: "organizations/304/programs/253/applications/268"
                },
                {
                    name: "Central Carolina Community College",
                    applicationDefinitionId: "organizations/305/programs/256/applications/271"
                },
                {
                    name: "Central Piedmont Community College",
                    applicationDefinitionId: "organizations/306/programs/259/applications/274"
                },
                {
                    name: "Cleveland Community College",
                    applicationDefinitionId: "organizations/308/programs/265/applications/280"
                },
                {
                    name: "Coastal Carolina Community College",
                    applicationDefinitionId: "organizations/309/programs/268/applications/283"
                },
                {
                    name: "College of The Albemarle",
                    applicationDefinitionId: "organizations/310/programs/271/applications/286"
                },
                {
                    name: "Craven Community College",
                    applicationDefinitionId: "organizations/311/programs/274/applications/289"
                },
                {
                    name: "Davidson County Community College",
                    applicationDefinitionId: "organizations/313/programs/280/applications/295"
                },
                {
                    name: "Durham Technical Community College",
                    applicationDefinitionId: "organizations/315/programs/286/applications/301"
                },
                {
                    name: "Edgecombe Community College",
                    applicationDefinitionId: "organizations/317/programs/292/applications/307"
                },
                {
                    name: "Fayetteville Technical Community College",
                    applicationDefinitionId: "organizations/321/programs/304/applications/319"
                },
                {
                    name: "Forsyth Technical Community College",
                    applicationDefinitionId: "organizations/322/programs/307/applications/322"
                },
                {
                    name: "Gaston College",
                    applicationDefinitionId: "organizations/324/programs/313/applications/328"
                },
                {
                    name: "Guilford Technical Community College",
                    applicationDefinitionId: "organizations/353/programs/151/applications/166"
                },
                {
                    name: "Halifax Community College",
                    applicationDefinitionId: "organizations/385/programs/154/applications/169"
                },
                {
                    name: "Haywood Community College",
                    applicationDefinitionId: "organizations/386/programs/157/applications/172"
                },
                {
                    name: "Isothermal Community College",
                    applicationDefinitionId: "organizations/999/programs/999/applications/999"
                },
                {
                    name: "James Sprunt Community College",
                    applicationDefinitionId: "organizations/389/programs/166/applications/181"
                },
                {
                    name: "Johnston Community College",
                    applicationDefinitionId: "organizations/392/programs/175/applications/190"
                },
                {
                    name: "Lenoir Community College",
                    applicationDefinitionId: "organizations/394/programs/181/applications/196"
                },
                {
                    name: "Martin Community College",
                    applicationDefinitionId: "organizations/399/programs/196/applications/211"
                },
                {
                    name: "Mayland Community College",
                    applicationDefinitionId: "organizations/400/programs/199/applications/214"
                },
                {
                    name: "McDowell Technical Community College",
                    applicationDefinitionId: "organizations/401/programs/202/applications/217"
                },
                {
                    name: "Mitchell Community College",
                    applicationDefinitionId: "organizations/418/programs/325/applications/340"
                },
                {
                    name: "Montgomery Community College",
                    applicationDefinitionId: "organizations/419/programs/328/applications/343"
                },
                {
                    name: "Nash Community College",
                    applicationDefinitionId: "organizations/422/programs/340/applications/355"
                },
                {
                    name: "Pamlico Community College",
                    applicationDefinitionId: "organizations/430/programs/364/applications/379"
                },
                {
                    name: "Piedmont Community College",
                    applicationDefinitionId: "organizations/432/programs/370/applications/385"
                },
                {
                    name: "Pitt Community College",
                    applicationDefinitionId: "organizations/433/programs/373/applications/388"
                },
                {
                    name: "Randolph Community College",
                    applicationDefinitionId: "organizations/449/programs/388/applications/400"
                },
                {
                    name: "Richmond Community College",
                    applicationDefinitionId: "organizations/450/programs/391/applications/403"
                },
                {
                    name: "Roanoke-Chowan Community College",
                    applicationDefinitionId: "organizations/451/programs/397/applications/406"
                },
                {
                    name: "Robeson Community College",
                    applicationDefinitionId: "organizations/260/programs/121/applications/139"
                },
                {
                    name: "Rockingham Community College",
                    applicationDefinitionId: "organizations/259/programs/118/applications/136"
                },
                {
                    name: "Rowan-Cabarrus Community College",
                    applicationDefinitionId: "organizations/258/programs/115/applications/133"
                },
                {
                    name: "Sampson Community College",
                    applicationDefinitionId: "organizations/230/programs/106/applications/124"
                },
                {
                    name: "Sandhills Community College",
                    applicationDefinitionId: "organizations/229/programs/103/applications/121"
                },
                {
                    name: "South Piedmont Community College",
                    applicationDefinitionId: "organizations/227/programs/97/applications/115"
                },
                {
                    name: "Southeastern Community College",
                    applicationDefinitionId: "organizations/226/programs/94/applications/112"
                },
                {
                    name: "Southwestern Community College",
                    applicationDefinitionId: "organizations/225/programs/91/applications/109"
                },
                {
                    name: "Stanly Community College",
                    applicationDefinitionId: "organizations/210/programs/85/applications/100"
                },
                {
                    name: "Surry Community College",
                    applicationDefinitionId: "organizations/209/programs/82/applications/97"
                },
                {
                    name: "Tri-County Community College",
                    applicationDefinitionId: "organizations/208/programs/79/applications/94"
                },
                {
                    name: "Vance-Granville Community College",
                    applicationDefinitionId: "organizations/201/programs/49/applications/64"
                },
                {
                    name: "Wake Technical Community College",
                    applicationDefinitionId: "organizations/199/programs/43/applications/58"
                },
                {
                    name: "Warren Wilson College",
                    applicationDefinitionId: "organizations/198/programs/40/applications/55"
                },
                {
                    name: "Wayne Community College",
                    applicationDefinitionId: "organizations/197/programs/37/applications/52"
                },
                {
                    name: "Western Piedmont Community College",
                    applicationDefinitionId: "organizations/196/programs/76/applications/91"
                },
                {
                    name: "Wilkes Community College",
                    applicationDefinitionId: "organizations/195/programs/34/applications/49"
                },
                {
                    name: "Wilson Technical Community College",
                    applicationDefinitionId: "organizations/999/programs/999/applications/999"
                }
            ];

        }

    }

    angular.module("app").service(CommunityCollegeService.serviceId, CommunityCollegeService);
}